<template>
  <v-container>
    <v-row dense>
      <v-col v-if="user_can.add" cols="12">
        <v-btn router to="/ru/establecimiento" depressed class="primary">
          <v-icon left>mdi-plus</v-icon>
          Agregar establecimiento
        </v-btn>
      </v-col>
      <!-- listado de establecimientos en el almacenamiento local -->
      <v-col cols="12">
        <v-list two-line>
          <template v-for="registro in registros">
            <form-card
              :key="registro.id"
              :top-text="`${registro.nombre || '(sin nombre)'}`"
              :bottom-right-text="producerDescription(registro.productor)"
              :middle-text="`Finca • ${getNombreDeFinca(registro.id_finca)}`"
              :sincronized="registro.sincronizado"
              @click="traerRegistroYNavegar(registro)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { producerDescription } from '@/utilidades'

export default {
  name: 'Establecimientos',
  computed: {
    ...mapState('registros', {
      registros: 'establecimientos',
      fincas: 'fincas',
    }),
    ...mapGetters('registros', ['getNombreDeFinca']),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Establecimientos')
  },
  methods: {
    producerDescription,
    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getEstablecimiento', {
          id: registro.id,
        })
      }
      this.$router.push(`/ru/establecimiento/${registro.id}`)
    },
  },
}
</script>
